// eslint-disable-next-line no-unused-vars
import React, { createContext, useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';

import jwtDecode from 'jwt-decode';

import axios from '../utils/axios';
import Loader from '../components/Loader';
import authReducer from './auth-reducer/auth';
import { LOGIN, LOGOUT } from './auth-reducer/actions';

const initialState = {
  isLoggedIn: false,
  isInitialized: false,
  user: null,
};

const verifyToken = serviceToken => {
  if (!serviceToken) {
    return false;
  }
  const decoded = jwtDecode(serviceToken);
  return decoded.exp > Date.now() / 1000;
};

const setSession = serviceToken => {
  if (serviceToken) {
    localStorage.setItem('serviceToken', serviceToken);
    axios.defaults.headers.common.Authorization = `Bearer ${serviceToken}`;
  } else {
    localStorage.removeItem('serviceToken');
    delete axios.defaults.headers.common.Authorization;
  }
};

const JWTContext = createContext(null);

export const JWTProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);

  useEffect(() => {
    const init = async () => {
      try {
        const serviceToken = window.localStorage.getItem('serviceToken');
        if (serviceToken && verifyToken(serviceToken)) {
          setSession(serviceToken);
          const response = await axios.get('/api/auth/me');

          const user = response.data;

          setSession(user.token);

          dispatch({
            type: LOGIN,
            payload: {
              isLoggedIn: true,
              user,
            },
          });
        } else {
          dispatch({
            type: LOGOUT,
          });
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: LOGOUT,
        });
      }
    };

    init();
  }, []);

  const login = async (username, password) => {
    const response = await axios.post('/api/auth/token', {
      username,
      password,
    });

    const user = response.data;

    setSession(user.token);
    dispatch({
      type: LOGIN,
      payload: {
        isLoggedIn: true,
        user,
      },
    });
  };

  const logout = () => {
    setSession(null);
    dispatch({ type: LOGOUT });
  };

  if (state.isInitialized !== undefined && !state.isInitialized) {
    return <Loader />;
  }

  const serviceToken = window.localStorage.getItem('serviceToken');
  let roles = [];

  if (serviceToken && verifyToken(serviceToken)) {
    const { role } = jwtDecode(serviceToken);

    if (typeof role === 'undefined') {
      roles = [];
    } else {
      roles = typeof role === 'string' ? [role] : [...role];
    }
  }

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const value = {
    ...state,
    login,
    logout,
    isInRole: r => roles.includes(r),
  };

  return <JWTContext.Provider value={value}>{children}</JWTContext.Provider>;
};

JWTProvider.propTypes = {
  children: PropTypes.node,
};

export default JWTContext;
